import axios from "axios";
import { APIOverrides } from "../../ApiOverrides"
import type { HelpPromptProps, HelpTourProps } from "../../types";

//let EVENT_SVC_API = ''
let AUTH_SVC_API = ''
//let MK_SVC_API = ''
//let SOCIAL_SVC_API = ''

export { HelpApi }



const HelpApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        //EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        //MK_SVC_API = endpoints['MK_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        //SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
    },
    getHelpByNativeId: async(native_id:string):Promise<undefined | {view_type:'prompt'|'tour', help_prompt:HelpPromptProps, help_tour:HelpTourProps, tour_prompts:HelpPromptProps[], active_tour_prompt:string|undefined}> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/help/prompts/native_id/${native_id}`);
            return resp.data
        } catch (e) {
            console.log(e);
            return undefined
        }
    }
    
}

